export const blockIconsHomeSettingsAlertNew = (
	<span className='material-symbols-outlined'>settings_alert</span>
);
